import React, { useContext, useState, useEffect } from 'react';
import { useCallback } from 'react';

const PatientFormContext = React.createContext({
	fields: [],
	form: null,
	code: null
});

export const PatientFormProvider = ({ children }) => {
	const [info, setInfo] = useState({
		fields: [],
		form: null,
		code: null
	});

	const clearFormAndStorage = useCallback(() => {
		setInfo({
			fields: [],
			form: null,
			code: null
		});

		localStorage.removeItem('formInfo');
	}, []);

	useEffect(() => {
		const localStorageInfo = localStorage.getItem('formInfo');
		const localStorageInfoParsed = localStorageInfo ? JSON.parse(localStorageInfo) : null;

		if (localStorageInfoParsed) {
			setInfo(localStorageInfoParsed);
		}
	}, []);

	useEffect(() => {
		localStorage.setItem('formInfo', JSON.stringify(info));
	}, [info]);

	return (
		<PatientFormContext.Provider value={{
			...info,
			setInfo,
			clearFormAndStorage
		}}>
			{children}
		</PatientFormContext.Provider>
	)
}

export const usePatientFormContext = () => useContext(PatientFormContext);
